import {
  ActionModal,
  Button,
  colors,
  IMForm,
  IMSelect,
  Tooltip,
  typography,
} from '@insurancemenu/imenu-components-lib';
import { Status } from 'types/emailService';
import styled from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';

export const ActionModalStyled = styled(ActionModal)`
  max-width: 100rem;
  padding: 2.4rem 5.6rem;
  box-sizing: border-box;

  ${breakpointsMQ4.lg.down} {
    max-width: 90%;
  }
`;

export const IMFormStyled = styled(IMForm)`
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  max-width: 100%;
  padding: 0 0 2rem;
`;

export const SubmitButtonStyled = styled(Button)`
  margin-top: 2.8rem;
`;

export const TableSectionStyled = styled.div`
  margin-top: 4rem;
`;

export const TableSectionHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2rem;
`;

export const TextContentWrapperStyled = styled.div`
  text-align: left;
`;

export const TableSectionTitleStyled = styled.h3`
  ${typography.bold[20]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const NotifyAllUsersButtonStyled = styled(Button)`
  margin-left: auto;
`;

const EMAIL_STATUS_COLOR: Record<Status, string> = {
  [Status.NEW]: colors.blue[600],
  [Status.SENT]: colors.yellow[600],
  [Status.OPENED]: colors.green[600],
  [Status.BOUNCED]: colors.red[600],
  [Status.FAILED_TO_SEND]: colors.orange[600],
  [Status.BLOCK]: colors.red[600],
  [Status.INVALID]: colors.red[600],
  [Status.SPAM]: colors.red[600],
};

export const EmailStatusStyled = styled.p`
  ${typography.bold[16]}
  margin: 0.5rem 0;
  display: grid;
  grid-template-columns: 8rem 2.4rem;
  align-items: center;
`;

export const EmailStatusLabelStyled = styled.span<{ $status: Status }>`
  color: ${({ $status }): string => EMAIL_STATUS_COLOR[$status]};
  margin-right: 1rem;
`;

export const ActionCellWrapperStyled = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const SubmitButtonWrapperStyled = styled.div`
  position: relative;
`;

export const ErrorMessageStyled = styled.span`
  ${typography.regular[14]}
  color: ${colors.red[600]};
  position: absolute;
  bottom: -2.2rem;
  left: 0;
  right: 0;
  text-align: center;
`;

export const InfoBlockStyled = styled.div`
  ${typography.regular[16]}
  color: ${colors.neutral[900]};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const NoDataMessageStyled = styled(InfoBlockStyled)`
  margin-top: 3rem;
  justify-content: center;
`;

export const DisabledReasonsListStyled = styled.ul`
  list-style: disc;
  padding-left: 1rem;
  margin: 0;
`;

export const DisabledReasonsTooltipStyled = styled(Tooltip)`
  width: 40rem;
  white-space: wrap;

  &::before {
    left: 1rem;
  }
`;

export const TypeIMSelectStyled = styled(IMSelect)`
  flex: 0 0 20%;
`;

export const DeleteButtonStyled = styled(Button)`
  padding: 0;

  &:disabled {
    background-color: transparent;
    color: ${colors.neutral[500]};
  }
`;
